import items from './parameters-labels-data.json';

const methods = {
  minimalCorrelationLabelHandler: (vm, correlationTypeLabelSuffix) => {
    const correlationType = vm.$t(correlationTypeLabelSuffix);
    return vm.$t('fields.engineering.chromatography.minimal-correlation', { correlationType });
  },
  parametersLabelHandlerRate: (vm, gas) => {
    const chemicalElement = gas.toUpperCase();
    return vm.$t('fields.engineering.chromatography.typical-value-rate', { chemicalElement });
  },
  parametersLabelHandler: (vm, gas) => {
    const chemicalElement = gas.toUpperCase();
    return vm.$t('fields.engineering.chromatography.typical-value', { chemicalElement });
  },
};

const parametersLabels = (vm) => {
  if (!vm) return [];
  const parametersLabelsList = [];
  items.forEach(item => parametersLabelsList.push({
    label: methods[item.method](vm, item.label),
    key: item.key,
  }));
  return parametersLabelsList;
};

export default parametersLabels;
